<template>  
  <g :transform="`translate(${x}, ${y})`">  
    <!-- <circle :cx="0" :cy="0" r="10" fill="steelblue" />   -->
    <!-- <text :x="0" :y="5" text-anchor="middle">{{ node.label }}</text>   -->
    <svg :x="-50" :y="5" width="100" height="170">
      <foreignObject width="100%" height="100%">
        <div xmlns="http://www.w3.org/1999/xhtml" class="container"     >
          <div class="group-item" style="border:1px solid #000; height:80px; width:100px" :index="1" :nid="node.id" :subject_id="node.subject_id1">
            <p @click="nodeHandle(node)" style="padding: 5px">{{node.mingcheng1}}</p> 
            </div>
          <div class="group-item" style="border:1px solid #000; height:80px; width:100px;margin-top:5px"  :index="2"  :nid="node.id" :subject_id="node.subject_id2">
             <p @click="nodeHandle(node)" style="padding: 5px">{{node.mingcheng2}}</p> 
            </div>
         
        </div> 
      </foreignObject>
    </svg>
      
    <!-- 绘制连接线到子节点 -->  
    <g v-if="node.children && node.children.length > 0">  
      <!-- <line  
        v-for="(child, index) in node.children"  
        :key="child.id"  
        :x1="0"  
        :y1="20"  
        :x2="getChildX(index, node.children.length, level, width/(level+1),child)"  
        :y2="getLevelY(level + 1)"  
        :x="'0,20 '+getChildX(index, node.children.length, level, width/(level+1),child)+',20 '+getChildX(index, node.children.length, level, width/(level+1),child)+','+getLevelY(level + 1)"
        stroke="black"  
      />   -->

      <polyline
        v-for="(child, index) in node.children"  
        :key="child.id+'p'"  
            :points="'0,180 '+getChildX2(index)+',180 '+getChildX2(index)+','+(getLevelY(level + 1)+160)"
            style="fill:none;stroke:burlywood;stroke-width:2;stroke-linejoin:round"></polyline>  
            <!-- <polyline
        v-for="(child, index) in node.children"  
        :key="child.id"  
            :points="'0,120 '+getChildX(index, node.children.length, level, width/(level+1),child)+',120 '+getChildX(index, node.children.length, level, width/(level+1),child)+','+(getLevelY(level + 1)+100)"
            style="fill:none;stroke:burlywood;stroke-width:2;stroke-linejoin:round"></polyline>   -->
        
      <!-- 递归渲染子节点 -->  

        <!-- :x="getChildX(index, node.children.length, level, width/(level+1),child)"   -->
        <!-- :x="index==0?(-(4-level)*70):(4-level)*70"   -->
        

      <TreeNode  
        v-for="(child, index) in node.children"  
        :key="child.id"  
        :node="child"  
        :x="getChildX2(index)"  
        :y="getLevelY(level + 1)+160"  
        :level="level + 1"  
        :levels="levels"
        :width="width"  
      />  
    </g>  
  </g>  
</template>  
  
<script>  
export default {  
  name: 'TreeNode',  
  props: ['node', 'x', 'y', 'level', 'width','levels'],  
  methods: {  

    getChildX2(index){
      let level = this.level
      let maxLevel = this.levels //5
      return index==0?(-(Math.pow(2,maxLevel-2-level))*70):(Math.pow(2,maxLevel-2-level))*70
    },

// 计算子节点的X坐标  
    getChildX(index, totalChildren, level, svgWidth,node) {  


      const centerX = svgWidth / 2; // SVG画布的中心X坐标  
      let chilrenWidth = svgWidth/totalChildren //平均每个元素宽度
      console.log('chilrenWidth',node.label,level,chilrenWidth)
      // console.log('centerX',node.label,level,centerX)

      let cx = chilrenWidth/2 + chilrenWidth*(index)
      console.log('cx',node.label,level,index,cx)
      const childX  = cx - centerX;
 

      // console.log('svgWidth',svgWidth)
      // const padding_x = 50;
      // let chilrenWidth = (svgWidth-2*padding_x)/totalChildren //平均每个元素宽度


      // const childX = padding_x+ svgWidth/2+ svgWidth* (index-1); // SVG画布的中心X坐标  

      const spacing = 150; // 子节点之间的水平间距  
      const indent = 50; // 每级缩进的距离  
      // const centerX = svgWidth / 2; // SVG画布的中心X坐标  
      // const childX = centerX + (index - totalChildren / 2) * spacing * Math.pow(-1, level);  
      return childX;  
    },  
    // 计算子节点的Y坐标（基于层级）  
    getLevelY(level) {  
      // return level * 50; // 每级向下移动50单位  
      return 80; // 每级向下移动50单位  
    }  ,
    nodeHandle(node){
      // alert(node.label)
    }
  }  
};  
</script>  
  
<style scoped>  
/* 你可以在这里添加一些针对TreeNode组件的CSS样式 */  
</style>